module.exports = __webpack_public_path__ + "static/media/aboutproject.36962adb.png";